import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * @module org/locationtech/jts/io/GeoJSONReader
 */

import GeometryFactory from '../geom/GeometryFactory';
import GeoJSONParser from './GeoJSONParser';

/**
 * Converts a geometry in GeoJSON to a {@link Geometry}.
 */
var GeoJSONReader = /*#__PURE__*/function () {
  /**
   * A <code>GeoJSONReader</code> is parameterized by a <code>GeometryFactory</code>,
   * to allow it to create <code>Geometry</code> objects of the appropriate
   * implementation. In particular, the <code>GeometryFactory</code> determines
   * the <code>PrecisionModel</code> and <code>SRID</code> that is used.
   *
   * @param {GeometryFactory} geometryFactory
   */
  function GeoJSONReader(geometryFactory) {
    _classCallCheck(this, GeoJSONReader);
    this.parser = new GeoJSONParser(geometryFactory || new GeometryFactory());
  }

  /**
   * Reads a GeoJSON representation of a {@link Geometry}
   *
   * Will also parse GeoJSON Features/FeatureCollections as custom objects.
   *
   * @param {Object|String} geoJson a GeoJSON Object or String.
   * @return {Geometry|Object} a <code>Geometry or Feature/FeatureCollection representation.</code>
   * @memberof module:org/locationtech/jts/io/GeoJSONReader#
   */
  _createClass(GeoJSONReader, [{
    key: "read",
    value: function read(geoJson) {
      var geometry = this.parser.read(geoJson);
      return geometry;
    }
  }]);
  return GeoJSONReader;
}();
export { GeoJSONReader as default };